import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import i18n from 'i18next';

import Label from 'common/typography/Label/Label';
import Button from 'common/components/atoms/Button';
import FlexContainer from 'common/components/atoms/FlexContainer';
import Modal from 'common/components/organisms/ModalV2';
import InputField from 'common/components/atoms/InputField';
import {
  getDeviceTypes,
  getFirmwareTypes,
  getAssociationTypes,
  firmwareDeploymentConstants
} from '../constants/firmwareDeployment.constants';

const DeploymentModalContainer = styled(FlexContainer)`
  line-height: 0.2em;
`;

class UpdateDeploymentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firmwareId: this.props.details.association_type === 'devices' ? this.props.details.target_firmware_id : this.props.details.target_firmware_version,
      associations: this.props.details.association_values.map(assoc => assoc.id)
    };
  }

  renderFirmwareOptions = () => {
    const { details, metadata } = this.props;

    const firmwares = metadata.firmwares.map(
      fw => ({ value: fw.id, text: fw.version, model_version: fw.model_version })
    ) || [];

    return firmwares.filter((fw) => {
      if (details.device_type === firmwareDeploymentConstants.DEVICE_TYPE_MOTE) {
        return firmwareDeploymentConstants.MOTE_MODEL_VERSION === fw.model_version;
      }
      return firmwareDeploymentConstants.TX_MODEL_VERSION === fw.model_version;
    });
  }

  renderDeviceOptions = () => {
    const {
      firmwareId,
    } = this.state;
    const firmware = firmwareId && this.props.metadata.firmwares.find(it => it.id === firmwareId);
    const { details } = this.props;
    if (!firmware) return [];

    return _.filter(
      details.device_type === 'tx' ? this.props.metadata.tx : this.props.metadata.motes,
      device => (_.isEmpty(firmware.account_ids) || _.includes(firmware.account_ids, device.account_id)) && device.model === firmware.model_version
    ).map(
      device => ({ value: device.id, text: device.serial_number })
    );
  }

  updateDisabled = () => {
    const propAssoctions = this.props.details.association_values.map(assoc => assoc.id);
    const propFirmwareId = this.props.details.association_type === 'devices' ? this.props.details.target_firmware_id : this.props.details.target_firmware_version;
    return _.isEqual(propAssoctions, this.state.associations) && _.isEqual(propFirmwareId, this.state.firmwareId);
  }

  render() {
    const DEVICE_TYPES = getDeviceTypes(i18n.t.bind(i18n));
    const FIRMWARE_TYPES = getFirmwareTypes(i18n.t.bind(i18n));
    const ASSOCIATION_TYPES = getAssociationTypes(i18n.t.bind(i18n));
    const {
      close,
      update,
      details
    } = this.props;

    const {
      firmwareId,
      associations
    } = this.state;

    return (
    <Modal
      width="30%"
      close={close}
    >
      <DeploymentModalContainer direction="column" marginbottom="40px" margintop="40px">
        <FlexContainer direction="column" alignItems="left" marginbottom="40px">
          <Label fontWeight="300" fontSize="20px" marginBottom="8px">{i18n.t('firmwareDeployment.updateModal.title', { defaultValue: 'Update Deployment' })}</Label>
        </FlexContainer>
          <InputField
            label={i18n.t('firmwareDeployment.updateModal.deploymentNameLabel', { defaultValue: 'Deployment Name' })}
            maxLength={50}
            placeholder={i18n.t('firmwareDeployment.updateModal.deploymentNamePlaceholder', { defaultValue: 'Enter deployment name' })}
            type="text"
            value={details.name}
            disabled
          />
          <InputField
            label={i18n.t('devices.addDevice.deviceType', { defaultValue: 'Device Type' })}
            maxLength={50}
            placeholder={i18n.t('devices.addDevice.deviceTypePlaceholder', { defaultValue: 'Click to select device type' })}
            value={details.device_type}
            type="select"
            options={DEVICE_TYPES}
            disabled
          />
          <InputField
            label={i18n.t('firmwareDeployment.updateModal.firmwareTypeLabel', { defaultValue: 'Firmware Type' })}
            maxLength={50}
            placeholder={i18n.t('firmwareDeployment.updateModal.firmwareTypePlaceholder', { defaultValue: 'Click to select Firmware type' })}
            type="select"
            value={details.target_firmware_type}
            options={FIRMWARE_TYPES}
            disabled
          />
          {details.target_firmware_type && details.association_type === 'devices' ? (
            <InputField
              label={i18n.t('firmwareDeployment.updateModal.targetFirmwareVersionLabel', { defaultValue: 'Target Firmware Version' })}
              maxLength={50}
              onChange={(e, d) => this.setState({ firmwareId: d.value })}
              placeholder={i18n.t('firmwareDeployment.updateModal.targetFirmwareVersionPlaceholder', { defaultValue: 'Click to select target firmware version' })}
              type="select"
              search
              value={this.state.firmwareId}
              options={this.renderFirmwareOptions()}
            />
          ) :
            (
            <InputField
              label={i18n.t('firmwareDeployment.updateModal.targetFirmwareVersionLabel', { defaultValue: 'Target Firmware Version' })}
              maxLength={50}
              placeholder={i18n.t('firmwareDeployment.updateModal.targetFirmwareVersionPlaceholder', { defaultValue: 'Click to select target firmware version' })}
              type="text"
              value={this.state.firmwareId}
              disabled
            />
            )
        }
          {details.target_firmware_version && (
            <InputField
              label={i18n.t('firmwareDeployment.updateModal.associationTypeLabel', { defaultValue: 'Association Type' })}
              maxLength={50}
              placeholder={i18n.t('firmwareDeployment.updateModal.associationTypePlaceholder', { defaultValue: 'Click to select target firmware version' })}
              type="select"
              value={details.association_type}
              options={ASSOCIATION_TYPES}
              disabled
            />
          )}

          {details.association_type === 'devices' && (
            <InputField
              label={i18n.t('firmwareDeployment.updateModal.associatedDevicesLabel', { defaultValue: 'Associated Devices' })}
              onChange={(e, d) => this.setState({ associations: d.value })}
              placeholder={i18n.t('firmwareDeployment.updateModal.associatedDevicesPlaceholder', { defaultValue: 'Associated Devices' })}
              multiple
              type="select"
              search
              value={this.state.associations}
              options={this.renderDeviceOptions()}
            />
          )}
          {details.association_type === 'firmwares' && (
            <InputField
              label={i18n.t('firmwareDeployment.updateModal.associatedFirmwaresLabel', { defaultValue: 'Associated Firmwares' })}
              onChange={(e, d) => this.setState({ associations: d.value })}
              placeholder={i18n.t('firmwareDeployment.updateModal.associatedFirmwaresPlaceholder', { defaultValue: 'Associated Firmwares' })}
              multiple
              type="select"
              search
              value={this.state.associations}
              options={this.renderFirmwareOptions()}
            />
          )}
        <FlexContainer justifyContent="flex-end">
          <Button onClick={close} cancel margin="0 20px 0 0">{i18n.t('common.close', { defaultValue: 'Close' })}</Button>
          <Button
            onClick={() => update(associations, firmwareId)}
            disabled={this.updateDisabled()}
          >
            {i18n.t('common.update', { defaultValue: 'Update' })}
          </Button>
        </FlexContainer>
      </DeploymentModalContainer>
    </Modal>
    );
  }
}


UpdateDeploymentModal.propTypes = {
  update: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  details: PropTypes.object.isRequired
};

export default UpdateDeploymentModal;
